<button mat-button color="primary" (click)="back()">
   <mat-icon>arrow_back</mat-icon>
   Back
</button>
<div class="editor" [froalaEditor]="options">
   <div style="width: 100%; min-height: 10in;">
      <ng-container *ngIf="orgName">
         <div style="display: flex; justify-content: space-between;">
            <div style="display: flex;">
               <img *ngIf="logo" [src]="logo" style="height: 50px;" />
               <div style="font-size: 24pt; line-height: 60px;">{{ orgName }}</div>
            </div>
            <div
               style="
                  font-size: 10pt;
                  font-weight: bold;
                  text-transform: uppercase;
                  padding-top: 12pt;
                  text-align: right;
               "
            >
               Business Unit Summary
            </div>
         </div>
      </ng-container>
      <ng-container *ngIf="businessUnit">
         <div style="font-size: 20pt; font-weight: bold; margin-bottom: 12pt; margin-top: -4pt;">
            {{ businessUnit.name }}
         </div>
         <div>
            <div
               style="
                  font-size: 10pt;
                  font-weight: bold;
                  text-transform: uppercase;
                  color: #757575;
               "
            >
               Director
            </div>
            <div>{{ businessUnit.directorId | teamMemberName: teamMembers }}</div>
         </div>
         <div>
            <div
               style="
                  font-size: 10pt;
                  font-weight: bold;
                  text-transform: uppercase;
                  color: #757575;
               "
            >
               Purpose
            </div>
            <div>{{ businessUnit.purpose }}</div>
         </div>
         <div
            style="font-size: 10pt; font-weight: bold; text-transform: uppercase; color: #757575;"
         >
            Departments
         </div>
         <div style="padding-left: 12pt;">
            <ng-container *ngFor="let department of businessUnit.departments">
               <div style="font-size: 16pt;">
                  {{ department.name }}
               </div>
               <div style="padding-left: 12pt;">
                  <div
                     style="
                        font-size: 10pt;
                        font-weight: bold;
                        text-transform: uppercase;
                        color: #757575;
                     "
                  >
                     Manager
                  </div>
                  <div>{{ department.managerId | teamMemberName: teamMembers }}</div>

                  <div
                     style="
                        font-size: 10pt;
                        font-weight: bold;
                        text-transform: uppercase;
                        color: #757575;
                     "
                  >
                     Purpose
                  </div>
                  <div [innerHTML]="department.purpose"></div>
                  <div style="display: flex;">
                     <div
                        style="
                           flex: 1 1 25%;
                           font-size: 10pt;
                           font-weight: bold;
                           text-transform: uppercase;
                           color: #757575;
                        "
                     >
                        Function
                     </div>
                     <div
                        style="
                           flex: 1 1 25%;
                           font-size: 10pt;
                           font-weight: bold;
                           text-transform: uppercase;
                           color: #757575;
                        "
                     >
                        Lead
                     </div>
                     <div
                        style="
                           flex: 2 2 50%;
                           font-size: 10pt;
                           font-weight: bold;
                           text-transform: uppercase;
                           color: #757575;
                        "
                     >
                        Purpose
                     </div>
                  </div>
                  <ng-container *ngFor="let deptFn of department.departmentFunctions">
                     <div style="display: flex;">
                        <div style="flex: 1 1 25%;">{{ deptFn.name }}</div>
                        <div style="flex: 1 1 25%;">
                           {{ deptFn.leadId | teamMemberName: teamMembers }}
                        </div>
                        <div style="flex: 2 2 50%;">{{ deptFn.purpose }}</div>
                     </div>
                  </ng-container>
               </div>
            </ng-container>
         </div>
      </ng-container>
   </div>
</div>
